



























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class PageComponent extends Vue {
  private perPage: number = 50
  private displayCurrentPage: number = 1

  @Prop() isRequesting!: boolean
  @Prop() totalCount!: number
  @Prop() currentPage!: number

  updated () {
    this.displayCurrentPage = this.currentPage
  }

  private onPageChange (val: any) {
    if (this.displayCurrentPage !== this.currentPage) {
      this.$emit('change-page', this.displayCurrentPage)
    }
  }

  private resetCurrentPage () {
    this.displayCurrentPage = 1
  }
}
